export default __webpack_public_path__ + "static/media/Y_Forms.ed3625d6.png";